'use client';

import { useEffect } from 'react';

import { useFullUserInfo } from '@/hooks/auth/use-full-user-info';

declare global {
  interface Window {
    _hsq?: any[];
  }
}

export const HubspotTracker = () => {
  const { data } = useFullUserInfo();
  const email = data?.userInfo?.email;

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!email) return;

    window._hsq = window._hsq || [];

    window._hsq.push([
      'identify',
      {
        email,
      },
    ]);
  }, [email]);

  return null;
};
